module.exports = __webpack_public_path__ + "img/visa-old.29cda517.svg";